import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-99288f22")

_pushScopeId("data-v-99288f22")
const _hoisted_1 = { class: "container mt-n7" }
const _hoisted_2 = {
  key: 0,
  class: "blur-overlay"
}
const _hoisted_3 = { class: "save-first-message" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Commitment = _resolveComponent("Commitment")
  const _component_Notes = _resolveComponent("Notes")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "section",
        id: "dictionary1",
        style: { height: _ctx.sectionHeight }
      }, [
        _createVNode(_component_Commitment)
      ], 4),
      _createVNode("div", {
        class: "section",
        id: "dictionary2",
        style: { height: `calc(100% - ${_ctx.sectionHeight})` }
      }, [
        _createVNode(_component_Notes)
      ], 4)
    ]),
    (_ctx.showBlur)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.translate("blurMsg")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
})